import moment from 'moment';
import isAuthorized from '../../../helpers/isAuthorized';
import TruncatedCell from '../../Core/TruncatedCell';

const glue = '|';
const PayRatesListColumns = ({
  maxDescriptionLength,
  setSelected,
  approveAction,
  denyAction,
  viewAction,
  showEmployeeCollumn = false,
  user,
  chatAction,
}: {
  maxDescriptionLength: number;
  setSelected: (id: string) => void;
  approveAction: (e: any, id: string) => void;
  denyAction: (e: any, id: string) => void;
  viewAction: (e: any, id: string) => void;
  showEmployeeCollumn?: boolean;
  user: any;
  chatAction?: (id: string) => void;
}) => {
  const defaultCollumns = [
    {
      name: 'Employee Name',
      grow: 2,
      cell: (row: any) => {
        const firstName = row?.employee?.user?.firstName || '-';
        const lastName = row?.employee?.user?.lastName || '-';
        return `${firstName} ${lastName}`;
      },
    },
    {
      name: 'Date',
      grow: 1,
      cell: (row: any) => (row.createdAt ? moment(row.createdAt).format('MM/DD/YYYY') : '-'),
    },
    {
      name: 'Pay Rate',
      grow: 1,
      cell: (row: any) => {
        const payRateValue = row.payRate != null && !isNaN(parseFloat(row.payRate)) ? parseFloat(row.payRate) : null;
        return payRateValue != null ? '$' + payRateValue.toFixed(2) : '-';
      },
    },
    {
      name: 'Payment increase',
      grow: 1,
      cell: (row: any) =>
        row.percentIncrease && ['Changed', 'Approved', 'Waiting'].includes(row?.status)
          ? parseFloat(row.percentIncrease).toFixed(2) + '%'
          : '-',
    },
    {
      name: 'Reason',
      grow: 1,
      cell: (row: any) => <TruncatedCell text={row.reason} maxLength={40} />,
    },
    {
      name: 'Description',
      grow: 2,
      cell: (row: any) => {
        const descriptionText = row.description
          .map((d: any) => d?.text || '')
          .filter((text: string) => text.trim().length > 0)
          .join(glue);
        const hasDescription = descriptionText.length > 0;
        return (
          <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
            <button type="button" className="btn btn-link p-0 mr-1" onClick={() => setSelected(row.id)}>
              <i className="fas fa-pen text-primary" />
            </button>
            {hasDescription && (
              <button
                type="button"
                className="btn btn-link p-0 text-left"
                onClick={() => setSelected(row.id)}
                style={{ minWidth: 0 }}
              >
                <TruncatedCell text={descriptionText} maxLength={maxDescriptionLength} />
              </button>
            )}
          </div>
        );
      },
    },
    {
      name: 'Created By',
      grow: 2,
      cell: (row: any) => row.creator?.firstName + ' ' + row.creator?.lastName,
    },
    {
      name: 'Status',
      grow: 1,
      cell: (row: any) => row.status,
    },
    {
      name: 'Effective At',
      grow: 1,
      cell: (row: any) => moment(row.effectiveAt ?? row.approvedAt).format('MM/DD/YYYY'),
    },
    {
      name: 'Actions',
      width: '140px',
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: '6px' }}>
          <button
            type="button"
            className="btn btn-link p-0"
            title="View"
            onClick={(e) => {
              setSelected(row.id);
              viewAction(e, row?.id || '');
            }}
          >
            <i className="fas fa-eye text-info" />
          </button>
          {chatAction && (
            <button type="button" className="btn btn-link p-0" title="Chat" onClick={() => chatAction(row?.id || '')}>
              <i className="fas fa-comment text-primary" />
            </button>
          )}
          {isAuthorized({ moduleName: 'Employee', functionName: 'ApproveOrDenyPayRate' }, user) &&
            ['waiting'].includes(row?.status.toLowerCase()) && (
              <>
                <button
                  type="button"
                  className="btn btn-link p-0"
                  title="Approve"
                  onClick={(e) => approveAction(e, row?.id || '')}
                >
                  <i className="fas fa-check text-success" />
                </button>
                <button
                  type="button"
                  className="btn btn-link p-0"
                  title="Deny"
                  onClick={(e) => denyAction(e, row?.id || '')}
                >
                  <i className="fas fa-ban text-danger" />
                </button>
              </>
            )}
        </div>
      ),
    },
  ];

  return showEmployeeCollumn
    ? [
        ...[
          {
            name: 'Employee',
            grow: 2,
            cell: (row: any) => (
              <div className="d-flex align-items-center">
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                  <img
                    src={row?.employee?.user?.picture}
                    alt="User Profile"
                    className="img-fluid"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <span className="ml-2">{`${row?.employee?.user?.firstName || '-'} ${
                  row?.employee?.user?.lastName || '-'
                }`}</span>
              </div>
            ),
          },
        ],
        ...defaultCollumns.filter((col) => col.name !== 'Employee Name'),
      ]
    : defaultCollumns;
};
export default PayRatesListColumns;
